import { createSlice } from '@reduxjs/toolkit';

export const reporteSlice = createSlice({
    name: 'reporte',
    initialState: {
        reportes: [
            // tempEvent
        ],
        getDataForm: [],
    },
    reducers: {
        setReportes: (state, { payload } ) => {
            state.reportes = payload;
        }
    }
});


// Action creators are generated for each case reducer function
export const {
    setReportes,
} = reporteSlice.actions;